import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TableRow = _resolveComponent("TableRow");
    const _component_v_data_table = _resolveComponent("v-data-table");
    return (_openBlock(), _createBlock(_component_v_data_table, {
        hover: "",
        class: "hub-adjustment-data-table brg-table brg-card-inner-table",
        "hide-default-footer": "",
        "item-key": "code",
        "must-sort": "",
        items: _ctx.cardInfo.items,
        headers: _ctx.cardInfo.headers,
        density: "comfortable"
    }, {
        [`item`]: _withCtx(({ item }) => [
            _createVNode(_component_TableRow, {
                item: item,
                title: _ctx.cardInfo.title
            }, null, 8 /* PROPS */, ["item", "title"])
        ]),
        bottom: _withCtx(() => _cache[0] || (_cache[0] = [])),
        _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items", "headers"]));
}
